import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { ArrowPathIcon, TrashIcon, XCircleIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import { motion } from "framer-motion";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";

export default function ArchiveGrid({ leads, refreshLeads, open, onClose }) {
  const [confirmRestore, setConfirmRestore] = useState(null);
  const BACKEND_URL =
    window.location.hostname === "localhost"
      ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
      : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

  // ✅ Fonction pour restaurer un lead
  const handleRestore = async () => {
    if (!confirmRestore) return;
    try {
      await axios.put(`${BACKEND_URL}/leads/${confirmRestore._id}`, { statut: "Actif" });

      // ✅ Met à jour la liste sans recharger la page
      refreshLeads();
    } catch (error) {
      console.error("Erreur lors de la restauration :", error);
    }
    setConfirmRestore(null);
  };

  // ✅ Filtrer uniquement les leads ayant le statut "Sans Suite"
  const filteredLeads = leads.filter((lead) => lead.statut === "Sans Suite");

  const columns = [
    { field: "nom", headerName: "Nom", width: 150, headerAlign: "center", align: "center" },
    { field: "prenom", headerName: "Prénom", width: 150, headerAlign: "center", align: "center" },
    { field: "email", headerName: "Email", width: 200, headerAlign: "center", align: "center" },
    { field: "telephone", headerName: "Téléphone", width: 170, headerAlign: "center", align: "center" },
    { field: "referent", headerName: "Référent", width: 150, headerAlign: "center", align: "center" },
    { field: "commentaire", headerName: "Commentaires", width: 220, headerAlign: "center", align: "center" },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div className="flex gap-2">
          <button
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded-full text-sm transition"
            onClick={() => setConfirmRestore(params.row)}
          >
            <ArrowPathIcon className="w-4 h-4" />
            Restaurer
          </button>
          <button
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-1 rounded-full text-sm transition"
            onClick={() => alert("Suppression définitive non implémentée")}
          >
            <TrashIcon className="w-4 h-4" />
            Supprimer
          </button>
        </div>
      ),
    },
  ];

  return (
    <Dialog open={!!open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white p-6 rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
          >
            <XCircleIcon className="w-6 h-6" />
          </button>
          <DialogTitle className="text-xl font-bold mb-4 text-center">Archives des Leads</DialogTitle>

          <div className="w-full" style={{ height: "60vh" }}>
            <DataGrid
              rows={filteredLeads}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              checkboxSelection
              getRowId={(row) => row._id}
              style={{ height: "100%" }}
            />
          </div>

          {/* ✅ Confirmation de restauration (sous-dialog imbriqué) */}
          <Dialog open={!!confirmRestore} onClose={() => setConfirmRestore(null)} className="relative z-50">
            <DialogBackdrop className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
              <DialogPanel className="bg-white p-6 rounded-lg shadow-xl w-[400px]">
                <DialogTitle className="text-lg font-semibold text-center">Restaurer ce lead ?</DialogTitle>
                <p className="text-gray-600 text-center mt-2">
                  Êtes-vous sûr de vouloir restaurer{" "}
                  <strong>{confirmRestore?.nom} {confirmRestore?.prenom}</strong> ?
                </p>
                <div className="flex justify-between mt-4">
                  <button
                    className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-lg"
                    onClick={() => setConfirmRestore(null)}
                  >
                    Annuler
                  </button>
                  <button
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
                    onClick={handleRestore}
                  >
                    Confirmer
                  </button>
                </div>
              </DialogPanel>
            </div>
          </Dialog>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
